module.exports = __webpack_public_path__ + "images/168_4096.jpg";